import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { changeChartsLocationAction, changeFilterMenuListGetAction, changePublicFilterMenuListGetAction, changePublicShareChartsGetAction } from '../../../redux/actions';
import Spinner from '../../../components/Spinner';
//import { decryptData } from '../../../utils/encryptData';
const DashboardPageComponent = React.lazy(() => import('../../../components/GridLayoutDashboard/DashboardPageComponent'));


// تعریف تایپهای مورد نیاز
interface Chart {
    // تعریف خصوصیات نمودار
}

interface State {
    DashboardPage: {
        isLoading: boolean;
        chartList: Chart[];
    };
}

const Message = () =>
(
    <div style={{ height: 'calc(100vh - 180px)' }} className="text-center sanjabSpin">
        <div className="alert alert-info" role="alert">
            نموداری برای نمایش وجود ندارد
        </div>
    </div>
)

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const deSharing=async(jsonString:any)=>{
            
    let s:any=""
    // await decryptData(jsonString).then((result:any) => {
    //     s= result
    // })                    
    return s                                                                     
}

const PublicDashboardPage = () => {
    const location = useParams<{ id: string }>(); // استفاده از تایپهای دقیقتر برای پارامترها
    const query = useQuery();
    const data = query.get('data');
    const dispatch = useDispatch();
    
    const { isLoading, chartList } = useSelector((state: State) => state.DashboardPage);

    useEffect(() => {
        if (location.id) {
            dispatch(changeChartsLocationAction(location.id));
            dispatch(changePublicShareChartsGetAction({ id:location.id, encryptedString: data }));
            dispatch(changePublicFilterMenuListGetAction({ id:location.id, encryptedString: data }));
        }
    }, [location.id, dispatch]);

    if (isLoading) {
        return <Spinner />;
    }

    setTimeout(() => {
        if (!chartList || chartList.length === 0) {
            return <Message />;
        }
    }, 500)


    return (
        <Suspense fallback={<Spinner />}>
            <DashboardPageComponent />
        </Suspense>
    );
};

export default React.memo(PublicDashboardPage);